import {shortDocumentPattern} from './documentShortCode';
// Browser pages belong to the ERP host; API URLs retain their independent namespace.
export const erpHomePath = '/';
export const isErpHomePath = (path: string) => path === erpHomePath;
export const isErpHost = window.location.hostname === 'erp.withpot.com'
    || window.location.hostname === 'erp.sseeaa.cc'
    || (process.env.NODE_ENV === 'development' && (window.location.port === '3010'
        || window.location.hostname === process.env.REACT_APP_ERP_DEV_HOST));
// Logistics has its own root-relative pages, including /products.
export const isErpPath = (_path: string) => isErpHost;
export const erpSectionPath = (section: 'live' | 'purchase' | 'orders') =>
    ({live:'/live', purchase:'/purchases', orders:'/orders'}[section]);
export const isErpPagePath = (path: string) => /^\/(?:customers|orders|live|purchases|inventory|products|profile|catalog|settings|lab)(?:\/|$)/.test(path) || path === '/' || shortDocumentPattern.test(path);
